import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IQuotationScheduleDetailVO, IResponseModel } from '@agenda-customer-ui/shared';
import { API, environment } from '@core/envs';

@Injectable({
  providedIn: 'root'
})
export class QuotationsService {
  constructor ( private http: HttpClient ) { }

  getScheduleQuotation(advisorId: string, scheduleDate: string, scheduleHour: string, dealerId: string, country: string): Observable<IResponseModel<IQuotationScheduleDetailVO>> {
    const transformation = environment.getRoute(API.transformation);
    const url = `${transformation}/quotations?advisor=${advisorId}&country=${country}&date=${scheduleDate}&dealer=${dealerId}&hour=${scheduleHour}`;
    return this.http.get<IResponseModel<IQuotationScheduleDetailVO>>(url);
  }
}
